export const JOB_PREFERENCE_MODEL = "job-preference";

const jobPreferenceModel = {
  jobPreferenceIds: "",
  jobPreferenceId: "",
  jobPreferenceType: ""
};

export default jobPreferenceModel;
